import { forwardRef, MouseEventHandler } from "react";

import { chakra } from "@chakra-ui/react";

import { focusable } from "@lib/theme/mixins";

const HtmlLinkWrapper = forwardRef<
  HTMLAnchorElement,
  { onClick?: MouseEventHandler<HTMLAnchorElement>; href?: string, children?: any }
>(({ children, onClick, href }, ref) => (
  <chakra.a ref={ref} href={href} onClick={onClick} sx={{ ...focusable }}>
    {children}
  </chakra.a>
));

HtmlLinkWrapper.displayName = "OptionalHtmlLink";
export default HtmlLinkWrapper;
